import { defineMessages } from 'react-intl';

export default defineMessages({
  relationshipId: {
    id: 'sentinel.components.transferPanel.relationshipId',
    defaultMessage: 'PayPal Relationship ID',
  },
  status: {
    id: 'sentinel.components.transferPanel.status',
    defaultMessage: 'Status',
  },
  establishedDate: {
    id: 'sentinel.components.transferPanel.establishedDate',
    defaultMessage: 'Established',
  },
});



// WEBPACK FOOTER //
// ./src/components/TransferPanelPayPal/messages.js